import { withTranslation } from "react-i18next";

import React from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { Link } from 'react-router-dom';
import { Footer } from '../Common/Footer';
import { Header } from '../Common/Header';
import additionals from '../../Models/additionals';
import Products from '../../Models/Products';
import SimpleReactValidator from 'simple-react-validator';
import Modal from 'react-modal';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};
class ContactUs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            _id: false,
            title: '',
            description: '',
            email: '',
            name: ''
        };

        SimpleReactValidator.addLocale('klingon', {
            integer: `${this.props.t('0')}`,
            max: `:attribute :max ${this.props.t('1')} .`,
            required: ` :attribute ${this.props.t('2')}`,
            min: `:attribute :min ${this.props.t('3')}`,
            email: `${this.props.t('4')}`
        });
        this.validator = new SimpleReactValidator({
            locale: 'klingon',
        })
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.postData = this.postData.bind(this);

    }
    componentDidMount() {
        window.scrollTo(0, 0)
        this.getData();
    }

    getData() {
        if (localStorage.getItem('info')) {
            var x = JSON.parse(localStorage.getItem('info'))
            if (x.email || x.first_name) {
                console.log(x.first_name)
                this.setState({ email: x.email, name: x.first_name })
            } else {
                this.setState({ email: '', name: '' })
            }
        } else {
            this.setState({ email: '', name: '' })
        }
    }

    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }
    updateChange(e) {
        this.setState({
            budgets: e.target.value,
            budgetValue: e.target.key
        })
    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }



    afterOpenModal() {
        // references are now sync'd and can be accessed.
        // this.subtitle.style.color = '#f00';
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }
    handleSubmit(e) {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.openModal();
        } else {
            // alert("入力{this.props.t('2')}");
            this.Notify();
            this.validator.showMessages();
        }
    }
    Notify() {
        toast(this.props.t('5'), {
            position: "top-center"
        });
    }

    postData(e) {
        document.getElementById("req_entry").disabled = true;
        e.preventDefault();
        // var logged_user = JSON.parse(window.localStorage.getItem('info'));
        let data = {
            email: this.state.email,
            content: this.state.description,
            name: this.state.name
        }
        console.log(data);
        additionals.saveMessage(data).then(res => {
            if (parseInt(res.data.status) === 200) {
                alert(this.props.t('7'));
                this.props.history.push('/');
            }
        })
    }


    render() {
        var x = JSON.parse(localStorage.getItem('info'))
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        const isTablet = (window.innerWidth < 1200 && window.innerWidth > 500);
        //for mobile responsive
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div>
                        {/* <button >Open Modal</button> */}
                        <Modal
                            isOpen={this.state.modalIsOpen}
                            onAfterOpen={this.afterOpenModal}
                            onRequestClose={this.closeModal}
                            style={customStyles}
                            contentLabel="Example Modal"
                        >
                            <div style={{ width: "850px", height: "400px", overflow: "auto" }}>
                                <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModal} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div style={{ padding: "1%" }}>
                                    <form>
                                        <fieldset style={{ border: "1px solid #008dc7", paddingLeft: "4%", paddingRight: "4%", paddingBottom: "4%" }}>
                                            <legend style={{ width: "22%", color: "#008dc7", fontSize: "20px" }}>{this.props.t('8')}</legend>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('9')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.name}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('10')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.email}</span>
                                                </div>
                                            </div>

                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('11')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7 card" style={{ border: '0px solid' }}>
                                                    {/* <span>{this.state.description}</span> */}
                                                    <span>
                                                        {this.state.description.split('\n').map(function (item, key) {
                                                            return (
                                                                <span key={key}>
                                                                    {item}
                                                                    <br />
                                                                </span>
                                                            )
                                                        })}
                                                    </span>
                                                </div>
                                            </div>
                                        </fieldset>


                                        <div>&nbsp;</div>
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModal} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>{this.props.t('12')}</button>&nbsp;
                                        <button id="req_entry" onClick={this.postData} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>{this.props.t('13')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-2"></div>
                            <div className="col-md-8">
                                <div className="">
                                    <div className="" style={{ textAlign: "left", fontSize: "20px", borderBottom: "1px solid #ccd0c9" }}>
                                        {this.props.t('14')}
                                    </div>
                                    <div className="pt-4">
                                        <form onSubmit={this.handleSubmit.bind(this)}>
                                            {(() => {
                                                var x = JSON.parse(localStorage.getItem('info'))
                                                if (localStorage.getItem('info')) {
                                                    return (
                                                        <div className="">
                                                            <div className="form-group">
                                                                {console.log(this.state.name)}
                                                                <label htmlFor="pwd"><span className="request_fonts mr-4"><b>{this.props.t('9')}</b></span><span style={{ color: "red", fontSize: "11px" }}>*{this.props.t('16')}</span></label>
                                                                <input style={{ padding: "2%", border: "1px solid #d8e6e8" }} type="text" className="catagory_select" id="title" placeholder="" value={this.state.name} />
                                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                                    {this.validator.message(this.props.t('9'), this.state.name, 'required')}
                                                                </span>
                                                            </div>
                                                            <div>&nbsp;</div>
                                                            <div className="form-group">
                                                                <label htmlFor="pwd"><span className="request_fonts mr-4"><b>{this.props.t('10')}</b></span><span style={{ color: "red", fontSize: "11px" }}>*{this.props.t('16')}</span></label>
                                                                <input style={{ padding: "2%", border: "1px solid #d8e6e8" }} type="text" className="catagory_select" id="title" placeholder="" value={this.state.email} />
                                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                                    {this.validator.message(this.props.t('10'), this.state.email, 'required|email')}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    )
                                                } else {
                                                    return (
                                                        <div className="">
                                                            {console.log(this.state.name)}
                                                            <div className="form-group">
                                                                <label htmlFor="pwd"><span className="request_fonts mr-4"><b>{this.props.t('9')}</b></span><span style={{ color: "red", fontSize: "11px" }}>*{this.props.t('16')}</span></label>
                                                                <input style={{ padding: "2%", border: "1px solid #d8e6e8" }} type="text" className="catagory_select" id="title" placeholder="" value={this.state.name} onChange={this.updateValue.bind(this, 'name')} />
                                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                                    {this.validator.message(this.props.t('9'), this.state.name, 'required')}
                                                                </span>
                                                            </div>
                                                            <div>&nbsp;</div>
                                                            <div className="form-group">
                                                                <label htmlFor="pwd"><span className="request_fonts mr-4"><b>{this.props.t('10')}</b></span><span style={{ color: "red", fontSize: "11px" }}>*{this.props.t('16')}</span></label>
                                                                <input style={{ padding: "2%", border: "1px solid #d8e6e8" }} type="text" className="catagory_select" id="title" placeholder="" value={this.state.email} onChange={this.updateValue.bind(this, 'email')} />
                                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                                    {this.validator.message(this.props.t('10'), this.state.email, 'required|email')}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            })()}
                                            <div>&nbsp;</div>
                                            <div className="form-group">
                                                <label htmlFor="pwd"><span className="request_fonts mr-4"><b>{this.props.t('11')}</b></span><span style={{ color: "red", fontSize: "11px" }}>*{this.props.t('16')}</span></label>
                                                <textarea className="form-control " rows="7" id="description" placeholder="" value={this.state.description} onChange={this.updateValue.bind(this, 'description')} ></textarea>
                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                    {this.validator.message(this.props.t('11'), this.state.description, 'required')}
                                                </span>
                                            </div>
                                            <div>
                                                <div className="button_div">
                                                    {/* {/ <Link to={'/request - confirm'}> /} */}
                                                    <ToastContainer />
                                                    <button type="submit" className="agree_button">{this.props.t('13')}</button>
                                                    {/* {/ </Link > /} */}
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-2"></div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
        //for desktop view
        else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div>
                        {/* <button >Open Modal</button> */}
                        <Modal
                            isOpen={this.state.modalIsOpen}
                            onAfterOpen={this.afterOpenModal}
                            onRequestClose={this.closeModal}
                            style={customStyles}
                            contentLabel="Example Modal"
                        >
                            <div style={{ width: "850px", height: "400px", overflow: "auto" }}>
                                <div className="col-md-12 row" style={{ maxHeight: "100px" }}>
                                    <div className="col-md-12" style={{ textAlign: "right" }}>
                                        <img style={{ cursor: "pointer" }} onClick={this.closeModal} alt="" src={require("../../assets/images/cute_cross.png")} height="20" width='20' />
                                    </div>
                                </div>
                                <div style={{ padding: "1%" }}>
                                    <form>
                                        <fieldset style={{ border: "1px solid #008dc7", paddingLeft: "4%", paddingRight: "4%", paddingBottom: "4%" }}>
                                            <legend style={{ width: "22%", color: "#008dc7", fontSize: "20px" }}>{this.props.t('8')}</legend>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('9')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.name}</span>
                                                </div>
                                            </div>
                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('10')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7">
                                                    <span>{this.state.email}</span>
                                                </div>
                                            </div>

                                            <div className="col-md-12 row">
                                                <div className="col-md-1"></div>
                                                <div className="col-md-3">
                                                    <span><i><b>{this.props.t('11')}</b></i></span>
                                                </div>
                                                <div className="col-md-1">:</div>
                                                <div className="col-md-7 card" style={{ border: '0px solid' }}>
                                                    {/* <span>{this.state.description}</span> */}
                                                    <span>
                                                        {this.state.description.split('\n').map(function (item, key) {
                                                            return (
                                                                <span key={key}>
                                                                    {item}
                                                                    <br />
                                                                </span>
                                                            )
                                                        })}
                                                    </span>
                                                </div>
                                            </div>
                                        </fieldset>


                                        <div>&nbsp;</div>
                                        <div style={{ textAlign: "center" }}>
                                            <button onClick={this.closeModal} style={{ borderRadius: "4px", border: "1px solid gray", backgroundColor: "white", color: "black", padding: "1%" }}>{this.props.t('12')}</button>&nbsp;
                                        <button id="req_entry" onClick={this.postData} style={{ borderRadius: "4px", border: "1px solid", backgroundColor: "#1eb2ef", color: "white", padding: "1%" }}>{this.props.t('13')}</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                    </div>
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-2"></div>
                                    <div className="col-md-8">
                                        <div className="">
                                            <div className="ml-5 mr-5" style={{ textAlign: "left", fontSize: "24px", borderBottom: "1px solid #ccd0c9" }}>
                                                {this.props.t('14')}
                                        </div>
                                            <div className="mini_padding">
                                                <div className="mini_padding inner-div">
                                                    <div className="container">
                                                        <form onSubmit={this.handleSubmit.bind(this)}>
                                                            {(() => {
                                                                var x = JSON.parse(localStorage.getItem('info'))
                                                                if (localStorage.getItem('info')) {
                                                                    return (
                                                                        <div className="">
                                                                            <div className="form-group">
                                                                                {console.log(this.state.name)}
                                                                                <label htmlFor="pwd"><span className="request_fonts mr-4"><b>{this.props.t('9')}</b></span><span style={{ color: "red", fontSize: "11px" }}>*{this.props.t('16')}</span></label>
                                                                                <input style={{ padding: "2%", border: "1px solid #d8e6e8" }} type="text" className="catagory_select" id="title" placeholder="" value={this.state.name} />
                                                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                                                    {this.validator.message(this.props.t('9'), this.state.name, 'required')}
                                                                                </span>
                                                                            </div>
                                                                            <div>&nbsp;</div>
                                                                            <div className="form-group">
                                                                                <label htmlFor="pwd"><span className="request_fonts mr-4"><b>{this.props.t('10')}</b></span><span style={{ color: "red", fontSize: "11px" }}>*{this.props.t('16')}</span></label>
                                                                                <input style={{ padding: "2%", border: "1px solid #d8e6e8" }} type="text" className="catagory_select" id="title" placeholder="" value={this.state.email} />
                                                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                                                    {this.validator.message(this.props.t('10'), this.state.email, 'required|email')}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                } else {
                                                                    return (
                                                                        <div className="">
                                                                            {/*{console.log(this.state.name)}*/}
                                                                            <div className="form-group">
                                                                                <label htmlFor="pwd"><span className="request_fonts mr-4"><b>{this.props.t('9')}</b></span><span style={{ color: "red", fontSize: "11px" }}>*{this.props.t('16')}</span></label>
                                                                                <input style={{ padding: "2%", border: "1px solid #d8e6e8" }} type="text" className="catagory_select" id="title" placeholder="" value={this.state.name} onChange={this.updateValue.bind(this, 'name')} />
                                                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                                                    {this.validator.message(this.props.t('9'), this.state.name, 'required')}
                                                                                </span>
                                                                            </div>
                                                                            <div>&nbsp;</div>
                                                                            <div className="form-group">
                                                                                <label htmlFor="pwd"><span className="request_fonts mr-4"><b>{this.props.t('10')}</b></span><span style={{ color: "red", fontSize: "11px" }}>*{this.props.t('16')}</span></label>
                                                                                <input style={{ padding: "2%", border: "1px solid #d8e6e8" }} type="text" className="catagory_select" id="title" placeholder="" value={this.state.email} onChange={this.updateValue.bind(this, 'email')} />
                                                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                                                    {this.validator.message(this.props.t('10'), this.state.email, 'required|email')}
                                                                                </span>
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                }
                                                            })()}
                                                            <div>&nbsp;</div>
                                                            <div className="form-group">
                                                                <label htmlFor="pwd"><span className="request_fonts mr-4"><b>{this.props.t('11')}</b></span><span style={{ color: "red", fontSize: "11px" }}>*{this.props.t('16')}</span></label>
                                                                <textarea className="form-control " rows="7" id="description" placeholder="" value={this.state.description} onChange={this.updateValue.bind(this, 'description')} ></textarea>
                                                                <span style={{ color: "red", fontSize: "12px" }}>
                                                                    {this.validator.message(this.props.t('11'), this.state.description, 'required')}
                                                                </span>
                                                            </div>
                                                            <div>
                                                                <div className="button_div">
                                                                    {/* {/ <Link to={'/request - confirm'}> /} */}
                                                                    <ToastContainer />
                                                                    <button type="submit" className="agree_button">{this.props.t('13')}</button>
                                                                    {/* {/ </Link > /} */}
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-2"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
// const mapStateToProps = (state) => ({
//     buyerRequest: state.buyerRequest,
//     errors: state.errors,
// });
// PostRequest = connect(mapStateToProps, { buyerRequest })(withRouter(PostRequest));
export { ContactUs }



 ContactUs = withTranslation('src_Components_StaticPages_ContactUs')(ContactUs);
